// SPDX-License-Identifier: AGPL-3.0-or-later
import type {AuthSessionLocation, AuthSessionResponse} from '@app/vendor/schema/domains/auth/AuthSchemas';
export class AuthSession {
	readonly id: string;
	readonly approxLastUsedAt: Date | null;
	readonly clientOs: string;
	readonly clientPlatform: string;
	readonly clientLocation: string | null;
	readonly isCurrent: boolean;
	private readonly clientInfo: AuthSessionResponse['client_info'] | null;
	constructor(data: AuthSessionResponse) {
		this.id = data.id_hash;
		this.approxLastUsedAt = data.approx_last_used_at ? new Date(data.approx_last_used_at) : null;
		this.clientInfo = data.client_info ?? null;
		this.clientOs = this.clientInfo?.os ?? 'Unknown';
		this.clientPlatform = this.clientInfo?.platform ?? 'Unknown';
		this.clientLocation = getLocationLabel(this.clientInfo?.location ?? null);
		this.isCurrent = data.current;
	}
	toJSON(): AuthSessionResponse {
		return {
			id_hash: this.id,
			approx_last_used_at: this.approxLastUsedAt?.toISOString() ?? null,
			client_info: this.clientInfo,
			current: this.isCurrent,
		};
	}
	equals(other: AuthSession): boolean {
		return JSON.stringify(this) === JSON.stringify(other);
	}
}
function getLocationLabel(location: AuthSessionLocation | null): string | null {
	if (!location) {
		return null;
	}
	const parts = [location.city, location.region, location.country].filter(Boolean);
	return parts.length ? parts.join(', ') : null;
}
